export function enumToSelectOptions<
  T extends Record<string, string | number>,
  K extends keyof T = keyof T,
>(
  enumObject: T,
  labelTransformer?: (value: T[K]) => string,
  constant: boolean = false,
): Array<{ value: T[K] | null; label: string; constant: boolean }> {
  return Object.entries(enumObject)
    .filter(([key]) => isNaN(Number(key)))
    .map(([, value]) => ({
      value: value as T[K],
      label: labelTransformer ? labelTransformer(value as T[K]) : String(value),
      constant,
    }));
}
